'use strict';

/** 与头部语言下拉一致，供 LanguageSwitch、页脚等共用 */
const SEND_UI_LANGUAGES = [
  { code: 'zh-CN', label: '简体中文' },
  { code: 'zh-TW', label: '繁體中文' },
  { code: 'en-US', label: 'English' },
  { code: 'ar', label: 'العربية' },
  { code: 'bn', label: 'বাংলা' },
  { code: 'de', label: 'Deutsch' },
  { code: 'es-ES', label: 'Español' },
  { code: 'fa', label: 'فارسی' },
  { code: 'fr', label: 'Français' },
  { code: 'he', label: 'עברית' },
  { code: 'hi', label: 'हिन्दी' },
  { code: 'id', label: 'Bahasa Indonesia' },
  { code: 'it', label: 'Italiano' },
  { code: 'ja', label: '日本語' },
  { code: 'ko', label: '한국어' },
  { code: 'ms', label: 'Bahasa Melayu' },
  { code: 'nl', label: 'Nederlands' },
  { code: 'pl', label: 'Polski' },
  { code: 'pt-PT', label: 'Português' },
  { code: 'pt-BR', label: 'Português (BR)' },
  { code: 'ru', label: 'Русский' },
  { code: 'sw', label: 'Kiswahili' },
  { code: 'ta', label: 'தமிழ்' },
  { code: 'th', label: 'ไทย' },
  { code: 'tl', label: 'Tagalog' },
  { code: 'tr', label: 'Türkçe' },
  { code: 'uk', label: 'Українська' },
  { code: 'ur', label: 'اردو' },
  { code: 'vi', label: 'Tiếng Việt' }
];

function getLanguageLabel(code) {
  const found = SEND_UI_LANGUAGES.find(l => l.code === code);
  return found ? found.label : code;
}

module.exports = { SEND_UI_LANGUAGES, getLanguageLabel };
